import {
    GroupsClient
} from '../clients/GroupsClient'
export const GroupsModule = {
    namespaced: true,
    state: {
        groups: [],
    },
    mutations: {

        SET_GROUPS(state, groups) {
            state.groups = groups
        },

    },

    actions: {

        fetch({
            commit
        }, payload) {
            return GroupsClient.getGroups(payload).then(({
                data
            }) => {
                commit('SET_GROUPS', data.data)
            })
        },

    },
};